import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ComponentFactoryResolver, ApplicationRef, Type } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NGFontAwesomeModule } from './global/ngfontawesome.module';
import { PrimengModule } from './global/primeng.module';
import { SharedModule} from './shared';

import { CoreModule } from './core/core.module';

import { PropertyModule } from './property/property.module';

import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { TasksComponent } from './tasks/tasks.component';
import { TaskListComponent } from './tasks/task-list/task-list.component';
import { PropertyComponent } from './property/property.component';
import { NewPropertyActivityComponent } from './property/new-property-activity/new-property-activity.component';
import { RecentlyCompletedTasksComponent } from './tasks/recently-completed-tasks/recently-completed-tasks.component';
import { PropertySearchComponent } from './property/property-search/property-search.component';
import { PropertyHeaderComponent } from './property/property-header/property-header.component';
import { HeaderDirective } from './property/property-header/header.directive';
import { AppComponent } from './app.component';
import { TaskCounterComponent } from './tasks/task-counter/task-counter.component';
import { ExpenseCounterComponent, ExpenseModule } from './expense';
import { PartnershipModule } from './partnership/partnership.module';
import { ManagePartnershipComponent } from './partnership/manage-partnership/manage-partnership.component';
import { PartnershipDetailComponent } from './partnership/manage-partnership/partnership-detail/partnership-detail.component';
import { EditProfileComponent } from './user/edit-profile/edit-profile.component';
import { ManageUserRelationshipComponent } from './partnership/manage-user-relationship/manage-user-relationship.component';
import { ManageAssetGroupComponent } from './partnership/manage-asset-group/manage-asset-group.component';
import { SettingModule, ConnectConfigurationComponent } from './setting';
import { ExpenseSearchComponent } from './expense/expense-search/expense-search.component';
import { AddMessageComponent } from './message/add-message/add-message.component';
import { MessageModule } from './message/message.module';
import { OfferDashboardComponent } from './offer/offer-dashboard/offer-dashboard.component';
import { OfferModule } from './offer/offer.module';
import { OfferCounterComponent } from './offer/offer-counter/offer-counter.component';
import { ManageUserGroupComponent } from './partnership/manage-user-group/manage-user-group.component';
import { QuickSearchComponent } from './property/quick-search/quick-search.component';
import { AssignedTasksComponent } from './tasks/assigned-tasks/assigned-tasks.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { HeaderSummaryComponent } from './property/property-header/header-summary/header-summary.component';
import { SidebarModule } from 'primeng/sidebar';
import { AuctionDetailsComponent } from './auction/auction-details/auction-details.component';
import { AuctionModule } from './auction/auction.module';
import { ChangeLogDetailsComponent } from './auction/change-log-details/change-log-details.component';

import { FavoritePropertiesComponent } from './property/favorite-properties/favorite-properties.component';
import { UserTasksComponent } from './tasks/user-tasks/user-tasks.component';
import { ManageBidInstructionModule } from './manage-bid-instruction/manage-bid-instruction.module';
import { ManageBidInstructionComponent } from './manage-bid-instruction/manage-bid-instruction.component';
import { ChangeLogBidInstructionComponent } 
  from './manage-bid-instruction/change-log-bid-instruction/change-log-bid-instruction.component';
import { ManageForeclosureAuctionComponent } from './manage-foreclosure-auction/manage-foreclosure-auction.component';
import { ChangeLogForeclsoureAuctionComponent } from './manage-foreclosure-auction/change-log-foreclsoure-auction/change-log-foreclsoure-auction.component';
import { ManageForeclosureAuctionModule } from './manage-foreclosure-auction/manage-foreclosure-auction-module';
import { ManageAuctionFeesComponent } from './manage-auction-fees/manage-auction-fees.component';
import { AddAuctionFeesComponent } from './manage-auction-fees/add-auction-fees/add-auction-fees.component';
import { ListAuctionFeesComponent } from './manage-auction-fees/list-auction-fees/list-auction-fees.component';
import { EditAuctionFeesComponent } from './manage-auction-fees/edit-auction-fees/edit-auction-fees.component';
import { ChangeLogAuctionFeesComponent } from './manage-auction-fees/change-log-auction-fees/change-log-auction-fees.component';
import { ManageAuctionFeesModule } from './manage-auction-fees/manage-auction-fees-module';
import { TaskSearchComponent } from './tasks/task-search/task-search.component';

const components = [
  AppComponent,
  NavMenuComponent,
  PropertyComponent,
  TasksComponent,
  TaskListComponent,
  RecentlyCompletedTasksComponent,
  NewPropertyActivityComponent,
  PropertyHeaderComponent,
  TaskCounterComponent,
  ExpenseCounterComponent,
  ManagePartnershipComponent,
  PartnershipDetailComponent,
  EditProfileComponent,
  ManageUserRelationshipComponent,
  ManageAssetGroupComponent,
  ConnectConfigurationComponent,
  ExpenseSearchComponent,
  AddMessageComponent,
  OfferCounterComponent,
  OfferDashboardComponent,
  ManageUserGroupComponent,
  QuickSearchComponent,
  AssignedTasksComponent,
  HeaderSummaryComponent,
  AuctionDetailsComponent,
  ChangeLogDetailsComponent,
  FavoritePropertiesComponent,
  UserTasksComponent,
  ManageBidInstructionComponent,
  ManageForeclosureAuctionComponent,
  ChangeLogBidInstructionComponent,
  ManageAuctionFeesComponent,
  TaskSearchComponent

];

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    TasksComponent,
    TaskListComponent,
    NewPropertyActivityComponent,
    RecentlyCompletedTasksComponent,
    PropertyHeaderComponent,
    HeaderDirective,
    TaskCounterComponent,
    ExpenseCounterComponent,
    EditProfileComponent,
    ExpenseSearchComponent,
    QuickSearchComponent,
    AssignedTasksComponent,
    HeaderSummaryComponent,
    FavoritePropertiesComponent,
    UserTasksComponent,
    TaskSearchComponent

   ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NGFontAwesomeModule,
    FontAwesomeModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    PropertyModule,
    SharedModule,
    PartnershipModule,
    ExpenseModule,
    SettingModule,
    MessageModule,
    OfferModule,
    DynamicDialogModule,
    AuctionModule,
    SidebarModule,
    ManageBidInstructionModule,
    ManageForeclosureAuctionModule,
    ManageAuctionFeesModule
    
  ],
  exports: [
    NavMenuComponent
  ],
  providers: [],
  entryComponents: components
})
export class AppModule {
  constructor(private resolver: ComponentFactoryResolver) { }
  ngDoBootstrap(appRef: ApplicationRef) {
    components.forEach((componentDef: Type<{}>) => {
      const factory = this.resolver.resolveComponentFactory(componentDef);
      if (document.querySelector(factory.selector)) {
        appRef.bootstrap(factory);
      }
    });
  }
}
